module.exports = __webpack_public_path__ + "static/media/Gopala13.6423884b.png";